import React from 'react';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export default function CustomSwitch({
  value, 
  onChange,
  data,
  loading,
  originPageContext,
  optionPageContext
}) {
  // 1 -> Pessoa Física (INTEGRATED_QUERY)
  // 2 -> Veículo (CAB_QUERY)
  // 3 -> Reboque (TOW_QUERY)
  // 4 -> Pessoa Jurídica (PERSON_QUERY)
  // 5 -> Conjunto (COMPANY_QUERY)
  // 6 -> Conjunto (JOIN_QUERY)
  data.map((item, key) => {
    // allowlegalPerson = true
    // allowNaturalPerson = true
    // allowVehicleLegalPerson = true
    // allowVehicleNaturalPerson = true
    // description = '.CAF - COMPLETO'
    // homologatorId = 6
    // id = 14
    switch (originPageContext) {
    case 'HomeConsultingJoin':
      data[key].removeItem = 
      !(item.allowNaturalPerson || item.allowVehicleLegalPerson || item.allowVehicleNaturalPerson);
      break;
    case 'HomeConsultingCorp':
      data[key].removeItem = !item.allowlegalPerson;
      break;
    case 'DriverConsulting':
      data[key].removeItem = !item.allowNaturalPerson;
      break;
    case 'OwnerConsulting':
      if (optionPageContext && optionPageContext === 'natural') {
        data[key].removeItem = !item.allowNaturalPerson;
      } else {
        data[key].removeItem = !item.allowlegalPerson;
      }
      break;
    case 'VehicleConsulting':
      data[key].removeItem = !(item.allowVehicleLegalPerson || item.allowVehicleNaturalPerson);
      break;
    default:
      break;
    }
  });

  return (
    <>
      <FormControl component="fieldset" margin="normal" style={{ marginTop: '32px' }}>
        <RadioGroup name="customSwitch" value={value} onChange={onChange} row>
          {
            data && data.map((item, key) => {
              if (!item.removeItem) {
                return (
                  <FormControlLabel 
                    disabled={loading}
                    value={`${item.id}`} 
                    control={<Radio color="primary" />} 
                    label={item.description}
                    key={key}
                  />
                );
              }
              return null;
            })
          }
        </RadioGroup>
      </FormControl>
    </>
  );
}